import lfRequest from '@/service/index'

export function checkPython() {
  return lfRequest.get<any>({
    url: '/main/workload/checkPython'
  })
}

export function runPython(queryInfo: any) {
  return lfRequest.post<any>({
    url: '/main/workload/runPython',
    data: queryInfo
  })
}
